import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toaster } from '../ui/sonner';

export function MainLayout() {
  const { sidebarCollapsed, currentUser } = useApp();

  // Individual (B2C) teachers get a single-page, focused experience — no
  // sidebar, no sidebar-aligned header offset, no nav shell. They only ever
  // see /teacher-assignments (enforced by RootGate).
  const isIndividual = currentUser?.role === 'teacher' && !currentUser?.schoolId;

  // Track viewport so the main-content margin only applies on ≥lg. Below lg,
  // the sidebar is a drawer overlay and main content fills the screen.
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== 'undefined' && window.innerWidth >= 1024);
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia('(min-width: 1024px)');
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  if (isIndividual) {
    return (
      <div className="min-h-screen bg-ae-bg dark:bg-slate-950 overflow-x-hidden" data-testid="individual-shell">
        <Header />
        <main className="pt-14 sm:pt-16 min-h-screen" data-testid="main-content">
          <div className="p-3 sm:p-4 lg:p-8 max-w-[1440px] mx-auto">
            <Outlet />
          </div>
        </main>
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ae-bg dark:bg-slate-950 overflow-x-hidden">
      <Sidebar />
      <Header />

      <main
        className="pt-14 sm:pt-16 min-h-screen transition-[margin-left] duration-300 ease-in-out"
        style={{ marginLeft: isDesktop ? (sidebarCollapsed ? 80 : 256) : 0 }}
        data-testid="main-content"
      >
        <div className="p-3 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>

      <Toaster position="top-right" />
    </div>
  );
}
